import { Popover } from 'antd';
import { Dispatch, ReactNode, SetStateAction, useState } from 'react';
import { CropwiseAiTabsEnum } from 'src/pages/cropwise-ai';
import { CropwiseAiHistory } from 'src/pages/cropwise-ai/cropwise-ai-history/cropwise-ai-history.component';

import * as Styled from './history-popover.style';

interface HistoryPopoverProps {
  showType: CropwiseAiTabsEnum;
  sessionId: string | null;
  setSessionId: Dispatch<SetStateAction<string | null>>;
  children: ReactNode;
}

const HistoryPopover = ({
  showType,
  sessionId,
  setSessionId,
  children,
}: HistoryPopoverProps) => {
  const [isHistoryOpen, setIsHistoryOpen] = useState(false);
  const content = (
    <Styled.PopoverContent>
      <CropwiseAiHistory
        showType={showType}
        sessionId={sessionId}
        setSessionId={setSessionId}
        setHistoryOpen={setIsHistoryOpen}
      />
    </Styled.PopoverContent>
  );

  return (
    <Popover
      content={content}
      trigger="click"
      open={isHistoryOpen}
      onOpenChange={setIsHistoryOpen}
      placement="bottomRight"
    >
      {children}
    </Popover>
  );
};

export { HistoryPopover };
